import request from "@/utils/request";

export const url = {
  GetCleanFlowPage: "/api/RoomNo/GetCleanFlowPage",

  StartCleaning: "/api/RoomNo/StartCleaning", //清洁员开始打扫
  EndCleaning: "/api/RoomNo/EndCleaning", //清洁员完成打扫
  AcceptCleaning: "/api/RoomNo/AcceptCleaning",
  CancelCleaning: "/api/RoomNo/CancelCleaning",
  SendPasswordAgain: "/api/RoomNo/SendPasswordAgain",
};
function sendRequest(apiUrl, params, type, opt = {}) {
  return request({
    ...opt,
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class roomServiceApi {
  static sendPasswordAgain(params, type = "post") {
    return sendRequest(url.SendPasswordAgain, params, type);
  }
  static cancelCleaning(params, type = "post") {
    return sendRequest(url.CancelCleaning, params, type);
  }
  static getCleanFlowPage(params, type = "post") {
    return sendRequest(url.GetCleanFlowPage, params, type);
  }
  static acceptCleaning(params, type = "post") {
    return sendRequest(url.AcceptCleaning, params, type);
  }
  static startCleaning(params, type = "post") {
    return sendRequest(url.StartCleaning, params, type);
  }
  static endCleaning(params, type = "post") {
    return sendRequest(url.EndCleaning, params, type);
  }
}
